






















import { Component, Model, Prop, Vue, Watch, Emit } from 'vue-property-decorator';

@Component
export class SearchForm extends Vue {
    public search: string = '';
    public activeFlags: string[] = [];
    public showFilters: boolean = false;
    @Prop() private labels!: object;
    @Watch('search')
    @Emit('search:text')
    private onSeachChanged(val: string, oldVal: string) {
        return val;
    }
    @Watch('activeFlags')
    @Emit('search:tag')
    private onTagChanged(val: string[]) {
        return val;
    }
    private updateSearch(val: string) {
        this.search = val;
    }
    private toggleFilters() {
        this.showFilters = !this.showFilters;
        this.onTagChanged(this.activeFlags);
    }
    private onClear() {
        this.search = '';
        // TODO, how to focus in TS ?
        // this.$refs.searchInput.focus();
    }
}
export default SearchForm;
